export const MODAL_SIZES = {
  xs: 350,
  sm: 450,
  md: 560,
  lg: 760,
  xl: 960,
} as const;

export const MODAL_Z_INDEX = {
  modalOverlay: 1100,
  modal: 1101,
  panelOverlay: 1200,
  panel: 1201,
} as const;

export const MODAL_ANIMATION = {
  duration: 0.2,
  dialog: {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.95 },
  },
  panel: {
    initial: (from: string) => {
      switch (from) {
        case 'left':
          return { x: '-100%' };
        case 'right':
          return { x: '100%' };
        case 'top':
          return { y: '-100%' };
        case 'bottom':
          return { y: '100%' };
        default:
          return { x: '100%' };
      }
    },
    animate: { x: 0, y: 0 },
    exit: (from: string) => {
      switch (from) {
        case 'left':
          return { x: '-100%' };
        case 'right':
          return { x: '100%' };
        case 'top':
          return { y: '-100%' };
        case 'bottom':
          return { y: '100%' };
        default:
          return { x: '100%' };
      }
    },
  },
  fullpage: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  },
} as const;

export const PANEL_WIDTH = {
  width: '50vw',
  minWidth: '600px',
  maxWidth: '800px',
} as const;
